jQuery(function ($) {
    
    // var slick = $(".hero-banner .slide-wrap");
    // // console.log(slick.length);
    // if (slick.length > 1){
    //     $('.hero-banner .slick').slick({
    //         SlideToShow: 1,
    //         SlideToScroll: 1,
    //         arrows: false,
    //         dots: true,
    //     });
    // }


    var slick = $(".hero-banner .inner-wrap");
    // console.log(slick.length);
    if (slick.length > 1){
        $('.hero-banner .slide-wrap').slick({
            SlideToShow: 1,
            SlideToScroll: 1,
            arrows: false,
            dots: true,
        });
    }
   
   
});
